import React from 'react';

import {components, OptionProps} from 'react-select';
import styled from 'styled-components';

import {colors, font} from 'theme';

const Label = styled.div<{isSelected?: boolean}>`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey1)};
    margin-bottom: 4px;
`;
const Subtitle = styled.div<{isSelected?: boolean}>`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 11px;
    line-height: 13px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey2)};
`;

const Description = styled.div<{isSelected?: boolean}>`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey2)};
`;

export const BrandNameOption = (props: OptionProps<any, false>) => {
    const {data, isSelected} = props;

    // eslint-disable-next-line no-underscore-dangle
    if (data.__isNew__) {
        return (
            <components.Option {...props}>
                <Label isSelected={isSelected} style={{fontWeight: 600, marginBottom: 0}}>
                    {data.label}
                </Label>
            </components.Option>
        );
    }

    const itemData: {brandName: string; owner: string; legalOwnerName: string} = data;

    return (
        <components.Option {...props}>
            <Label isSelected={isSelected}>{itemData.brandName}</Label>
            {/*<Subtitle isSelected={isSelected}>{itemData.owner}</Subtitle>*/}
            <Description isSelected={isSelected}>{itemData.legalOwnerName}</Description>
        </components.Option>
    );
};
